/**
 * Detects URL shapes produced by MSAL OAuth redirects so auth guards
 * do not navigate away before redirect handling completes.
 */
export function isBrowserMsalOAuthRedirect(): boolean {
  if (typeof window === 'undefined') return false;
  const urlParams = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(window.location.hash.substring(1));
  return (
    urlParams.has('code') ||
    urlParams.has('id_token') ||
    urlParams.has('access_token') ||
    hashParams.has('id_token') ||
    hashParams.has('access_token') ||
    urlParams.has('error') ||
    hashParams.has('error')
  );
}
